import { ReadMappingData } from '@/endpoints/schemas'
import { GeneralNodeActions } from '@/store/modules/tab/types'
import { updateTabData } from '@/store/utils'
import { NativeMap } from '@/utils/collections'

import { ensureValidData, getStructureSerializedData } from '../helpers'
import { TAB_CLOSE } from '../tab/constants'
import { Actions } from './actions'
import {
	MAPPING_READ_INIT,
	MAPPING_READ_SAVE,
	MAPPING_READ_SELECT_TAB,
	MAPPING_READ_UPDATE} from './constants'
import { defaultReadMappingData,getInitialReadMappingData } from './helpers'
import { OpenedReadMappingData, ReadMappingTab } from './types'

type State = Readonly<typeof initialState>

const initialState = {
	mappings: {} as NativeMap<OpenedReadMappingData>
}

export default (
	state = initialState,
	action: Actions | GeneralNodeActions
): State => {
	switch (action.type) {
		case TAB_CLOSE: {
			const mappings = { ...state.mappings }
			delete mappings[action.nodeId]

			return {
				...state,
				mappings
			}
		}

		case MAPPING_READ_INIT: {
			const { node, editMode, force } = action

			const previous = state.mappings[node.id]

			if (previous && editMode && previous.parsedEditMode && !force) {
				return state
			}

			const serializedData = getStructureSerializedData(node, editMode)

			// TODO: we should validate data against the JSON schema
			const parsed = JSON.parse(serializedData || '{}')

			const data: ReadMappingData = Object.keys(parsed).length
				? ensureValidData(parsed, defaultReadMappingData)
				: getInitialReadMappingData(node.name)

			if (!data.columns) {
				data.columns = []
			}

			if (typeof data.columnsLastId !== 'number') {
				data.columnsLastId = Math.max(0, ...data.columns.map(c => c.id))
			}

			return {
				...state,
				mappings: {
					...state.mappings,
					[node.id]: {
						form: data,
						original: data,
						stereotypeId: node.stereotypeId,
						tab: previous ? previous.tab : ReadMappingTab.Overview,
						dirty: false,
						parsedEditMode: editMode
					} as OpenedReadMappingData
				}
			}
		}

		case MAPPING_READ_SAVE: {
			const { node } = action.metadata

			return {
				...state,
				mappings: updateTabData(state.mappings, node.id, node => ({
					...node,
					dirty: false
				}))
			}
		}

		case MAPPING_READ_UPDATE: {
			const { node, update } = action

			return {
				...state,
				mappings: updateTabData(state.mappings, node.id, node => ({
					...node,
					form: {
						...node.form,
						...update
					},
					dirty: true
				}))
			}
		}

		case MAPPING_READ_SELECT_TAB: {
			return {
				...state,
				mappings: updateTabData(state.mappings, action.node.id, {
					tab: action.tab
				})
			}
		}

		default:
			return state
	}
}
